import React from "react";
import { Policy } from "../components/policy";

export default function () {
  return <Policy />;
}
